<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink="../" aria-label="Odpady komunalne">Odpady komunalne</a>
    </li>
    <li>
      {{ loading() ? 'Trwa ładowanie danych...' : area()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    @if (loading()) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    } @else {
      <h2>
        {{ area()?.name }}
      </h2>
      <div class='row'>
        <div class="col-12">
          <p>
            <strong>Harmonogram dotyczy ulic:</strong> {{ (area()?.streetList || '').split(":").at(1) }}
          </p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <table class="table mb-3">
            <thead>
            <tr>
              <th style="width: 10rem">
                Data
              </th>
              <th>
                Typ
              </th>
            </tr>
            </thead>
            <tbody>
              @for (item of scheduleCollection(); track $index) {
                <tr [style.background-color]="item?.collectionType?.colorHex ? '#' +item?.collectionType?.colorHex : 'inherit'">
                  <td>
                    {{ item?.pickupDate | date }}
                  </td>
                  <td>
                    {{ item?.collectionType?.name }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </section>
</app-content>
